function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from '../utils/classNames';
import Icon from '../Icon';

var ToastMessage = /*#__PURE__*/function (_PureComponent) {
  _inherits(ToastMessage, _PureComponent);

  var _super = _createSuper(ToastMessage);

  function ToastMessage() {
    _classCallCheck(this, ToastMessage);

    return _super.apply(this, arguments);
  }

  _createClass(ToastMessage, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          iconType = _this$props.iconType,
          shouldShow = _this$props.shouldShow,
          message = _this$props.message;
      var iconColor = /error/i.test(iconType) ? 'psw-c-alert-3' : 'psw-c-alert-1';
      var animation = null;

      if (/^check$/i.test(iconType) && shouldShow) {
        animation = 'psw-stroke-draw';
      } else if (/^check$/i.test(iconType) && !shouldShow) {
        animation = 'psw-stroke-erase';
      }

      return /*#__PURE__*/React.createElement("span", {
        className: classNames('psw-l-line-left-top', 'psw-l-space-x-xs')
      }, /*#__PURE__*/React.createElement("span", {
        className: animation,
        style: {
          transitionDelay: '350ms'
        }
      }, /*#__PURE__*/React.createElement(Icon, {
        className: classNames(iconColor),
        type: iconType,
        size: "m"
      })), /*#__PURE__*/React.createElement("span", null, message));
    }
  }]);

  return ToastMessage;
}(PureComponent);

ToastMessage.defaultProps = {
  shouldShow: false,
  iconType: '',
  message: ''
};
ToastMessage.propTypes = {
  shouldShow: PropTypes.bool,
  iconType: PropTypes.string,
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
};
export default ToastMessage;